// extracted by mini-css-extract-plugin
export default {"divchatbot":"chatbot_divchatbot__qqueP","inputchatbot":"chatbot_inputchatbot__uxaO8","submitchatbot":"chatbot_submitchatbot__cZiqW"};